@import (reference) 'ui-components/components/text/text.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.customer-communication-section-content {
  padding: @space-0 @space-16 @space-16;
}

.od-canvas-customer-communication {
  max-width: 350px;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: @space-12;

  padding-top: @space-0;
  color: var(--default--text-color--16);

  :global div.select-container {
    div.brand-label,
    label {
      color: var(--default--text-color--17);
      .label();
    }

    button {
      color: var(--default--text-color--16);
    }
  }
}
